"use client"

import { createContext, useContext } from "react"

export const DialogEntryContext = createContext<string | null>(null)
export const useDialogEntryId = () => useContext(DialogEntryContext)
